import { NOTE_OPTIONS } from "../lib/format";

/**
 * Small inline note selector. Calls onChange(newNote|null).
 */
export default function NoteSelect({ value, onChange, testId, compact }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      onClick={(e) => e.stopPropagation()}
      className={`bg-white border border-[#E5E5E5] rounded-sm text-xs px-2 py-1 ${
        compact ? "max-w-[180px]" : "w-full"
      } font-mono-tabular text-[#525252] hover:border-[#0A0A0A] focus:outline-none focus:border-[#0A0A0A]`}
      data-testid={testId}
    >
      <option value="">— No note —</option>
      {NOTE_OPTIONS.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  );
}
